import axios, { AxiosRequestConfig } from "axios";
import { identity, pickBy } from "lodash";
import Customer from "../models/Customer";
import CustomerAddress from "../models/CustomerAddress";
import { UUID } from "../utils";
import { getCustomer } from "./Customers";
import getErrorDetails from "./helpers/getErrorDetails";

export type PostCustomerAddress = (
  id: UUID,
  data: CustomerAddress,
  options?: AxiosRequestConfig
) => Promise<Customer>;

export type PatchCustomerAddress = (
  id: UUID,
  data: CustomerAddress,
  options?: AxiosRequestConfig
) => Promise<Customer>;

export const postCustomerAddress: PostCustomerAddress = async (
  id,
  address,
  options
) => {
  try {
    await axios({
      ...options,
      method: "POST",
      url: `/customers/${id}/addresses`,
      data: pickBy(address, identity),
    });
    return await getCustomer(id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};

export const patchCustomerAddress: PatchCustomerAddress = async (
  id,
  address,
  options
) => {
  try {
    await axios({
      ...options,
      method: "PUT",
      url: `/addresses/${address.id}`,
      data: pickBy(address, identity),
    });
    return await getCustomer(id, options);
  } catch (error) {
    throw getErrorDetails(error);
  }
};
